import { useEffect, useState } from 'react';

import { EditableValue } from '@/components/EditableValue/EditableValue';

import { useUpdateSessionName } from './hooks/useUpdateSessionName';

export function EditableExperimentName({
  sessionName,
  sessionId,
  textClassProp,
  pencilClassProp,
  inputTextClassProp,
  onValueClick,
  valueClickTooltipTitle,
  readOnly,
}: {
  sessionName: string;
  sessionId?: string;
  textClassProp?: string;
  pencilClassProp?: string;
  inputTextClassProp?: string;
  onValueClick?: () => void;
  valueClickTooltipTitle?: string;
  readOnly?: boolean;
}) {
  const [experimentName, setExperimentName] = useState(sessionName);
  const updateSession = useUpdateSessionName(sessionId, () => {
    setExperimentName(sessionName);
  });

  useEffect(() => {
    setExperimentName(sessionName);
  }, [sessionName, sessionId]);

  return (
    <EditableValue
      value={experimentName}
      onSubmit={(newText) => {
        if (sessionId) {
          updateSession({
            json: {
              name: newText,
            },
          });
        }
      }}
      onError={() => setExperimentName(sessionName)}
      tooltipTitle="Edit experiment name"
      textClassProp={textClassProp}
      pencilClassProp={pencilClassProp}
      inputTextClassProp={inputTextClassProp}
      onValueClick={onValueClick}
      valueClickTooltipTitle={valueClickTooltipTitle}
      readOnly={readOnly}
    />
  );
}
